import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "customer",
  "asset",
  "title",
  "total",
  "outcome",
  "revision",
  "work_order",
  "department",
  "valid_until",
  "sales_rep",
  "created",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Quote no.",
  customer: "Customer",
  asset: "Asset",
  title: "Title",
  total: "Total",
  outcome: "Outcome",
  revision: "Rev",
  work_order: "WO no.",
  department: "Department",
  valid_until: "Valid until",
  sales_rep: "Sales rep",
  created: "Created",
  updated: "Updated",
}

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "quotes",
  widths: {
    number: 8,
    customer: 10,
    asset: 6,
    title: 14,
    total: 9,
    outcome: 6,
    revision: 3.5,
    work_order: 6,
    department: 7,
    valid_until: 6,
    sales_rep: 5,
    created: 7.5,
    updated: 7.5,
    status: 2,
    actions: 4,
  },
  fill: "title",
  pinned: ["status", "actions"],
  extras: ["status", "actions"],
  dropOrder: [
    "created",
    "work_order",
    "revision",
    "department",
    "sales_rep",
    "valid_until",
    "outcome",
    "updated",
    "asset",
    "total",
    "customer",
  ],
}

export type Slot = Column | "status" | "actions"

export function withNumber(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "number" || columns.includes(column),
  )
}

export function slotsOf(columns: Column[], withStatus: boolean): Slot[] {
  const rest = COLUMNS.filter(
    (column) => column !== "number" && columns.includes(column),
  )
  const status: Slot[] = withStatus ? ["status"] : []
  return ["number", ...status, ...rest, "actions"]
}
